export default {
  computed: {
    site () {
      return this.$store.state.content['/*'] || {}
    },
    hasSite () {
      return !!Object.keys(this.site).length
    },
    page () {
      const pathname = this.$route.path
      return this.$store.state.content[pathname] || {}
    },
    hasPage () {
      return !!Object.keys(this.page).length
    },
    isNotFound () {
      return this.page && this.page.url === '/error'
    }
  }
}